import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.sort.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs';
import DepTree from '@/components/dep-tree';
import Job from '@/components/jobSelect';
import DetailTooltip from '_c/detail-tooltip';
import { CHEAT_DETAIL_FIELDS, DEVICE_DETAIL_FIELDS } from './constants';
import { sysInfoFn } from 'api/org/per';
function createDefaultTime() {
  var start = dayjs().startOf('month').format('YYYY-MM-DD');
  var current = dayjs(new Date().getTime()).format('YYYY-MM-DD');
  return [start, current];
}
var _createDefaultTime = createDefaultTime(),
  _createDefaultTime2 = _slicedToArray(_createDefaultTime, 2),
  s = _createDefaultTime2[0],
  e = _createDefaultTime2[1];
function createQueryModel() {
  return {
    search_name: '',
    // 开始时间
    attendance_start_date: s,
    // 结束时间
    attendance_end_date: e,
    // 页码
    page: 1,
    // 页数
    page_size: 20,
    // 部门id
    department_id: undefined,
    // 职位id
    job_title_id: undefined,
    // 在职状态，默认1在职，3待离职
    states: ['1', '3'],
    // 排序字段
    sort: '',
    // 升序降序（ ascending：升序，descending：降序）
    dir: ''
  };
}
export default {
  components: {
    DepTree: DepTree,
    Job: Job,
    DetailTooltip: DetailTooltip
  },
  data: function data() {
    var _this = this;
    return {
      CHEAT_DETAIL_FIELDS: CHEAT_DETAIL_FIELDS,
      DEVICE_DETAIL_FIELDS: DEVICE_DETAIL_FIELDS,
      defaultTime: createDefaultTime(),
      queryModel: createQueryModel(),
      department_name: '',
      punchRecordList: [],
      jobState: [],
      totalPage: 0,
      queryLoading: false,
      exportLoading: false,
      popover: false,
      minDate: false,
      /** @description 不限制开始时间 限制选择长度为最多为6个月 */
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          var minDate = _this.minDate;
          if (!minDate) return false;
          return time < minDate - 15552000000 || time > minDate.getTime() + 15552000000;
        },
        onPick: function onPick(params) {
          _this.minDate = params.minDate;
          if (params.maxDate) _this.minDate = false;
        }
      }
    };
  },
  created: function created() {
    this.getPunchRecordList();
    this.getJobState();
  },
  methods: {
    getPunchRecordList: function getPunchRecordList() {
      var _this2 = this;
      return new Promise(function (resolve) {
        _this2.$http({
          url: '/web/statistics/attendancelogs',
          params: _this2.queryModel
        }).then(function (res) {
          _this2.punchRecordList = res.data.body;
          _this2.totalPage = res.data.count;
        }).finally(function () {
          resolve();
        });
      });
    },
    getJobState: function getJobState() {
      var _this3 = this;
      sysInfoFn().then(function (res) {
        _this3.jobState = res.data.state;
      });
    },
    handleQuery: function handleQuery() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this4.queryLoading = true;
              _context.next = 3;
              return _this4.getPunchRecordList();
            case 3:
              _this4.queryLoading = false;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleExport: function handleExport() {
      var _this5 = this;
      this.exportLoading = true;
      this.$http({
        url: 'web/statistics/exportattendancelogs',
        data: this.queryModel
      }).then(function (res) {
        window.location.href = res.data;
      }).finally(function () {
        _this5.exportLoading = false;
      });
    },
    handleSortChange: function handleSortChange(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      this.queryModel.sort = prop;
      this.queryModel.dir = order;
      this.getPunchRecordList();
    },
    /**@description 日期更改 */handlerInputChange: function handlerInputChange(obj) {
      if (!obj) this.minDate = false;
      var _ref2 = obj || ['', ''];
      var _ref3 = _slicedToArray(_ref2, 2);
      this.queryModel.attendance_start_date = _ref3[0];
      this.queryModel.attendance_end_date = _ref3[1];
    },
    handleNodeClick: function handleNodeClick(val) {
      this.department_name = (val === null || val === void 0 ? void 0 : val.department_name) || '';
      this.queryModel.department_id = (val === null || val === void 0 ? void 0 : val.department_id) || '';
      this.popover = false;
    }
  }
};